import HomeComponent from "../../components/frontend/home/HomeComponent";
import WishlistComponent from "../../components/frontend/wishlist/WishlistComponent";
import OrderHistoryComponent from "../../components/frontend/account/orderHistory/OrderHistoryComponent";
import ReturnOrdersComponent from "../../components/frontend/account/returnOrders/ReturnOrdersComponent";
import ReturnOrderDetailsComponent from "../../components/frontend/account/returnOrders/ReturnOrderDetailsComponent";
import ReturnOrderRequestComponent from "../../components/frontend/account/returnOrders/ReturnOrderRequestComponent";
import OrderDetailsComponent from "../../components/frontend/account/orderDetails/OrderDetailsComponent";
import ChangePasswordComponent from "../../components/frontend/account/changePassword/ChangePasswordComponent";
import AddressComponent from "../../components/frontend/account/address/AddressComponent";
import PageComponent from "../../components/frontend/page/PageComponent";
import ProductComponent from "../../components/frontend/product/ProductComponent";
import ProductDetailsComponent from "../../components/frontend/product/ProductDetailsComponent";
import PromotionProductComponent from "../../components/frontend/product/PromotionProductComponent";
import ProductSectionProductComponent from "../../components/frontend/product/ProductSectionProductComponent";
import FlashSaleProductComponent from "../../components/frontend/product/FlashSaleProductComponent";
import OfferProductComponent from "../../components/frontend/product/OfferProductComponent";
import CategoryGridComponent from "../../components/frontend/category/CategoryGridComponent.vue";
import CategoryChildrenGridComponent from "../../components/frontend/category/CategoryChildrenGridComponent.vue";
import OverviewComponent from "../../components/frontend/account/overview/OverviewComponent";
import AccountComponent from "../../components/frontend/account/AccountComponent";
import AccountInfoComponent from "../../components/frontend/account/accountInfo/AccountInfoComponent";
import CheckoutComponent from "../../components/frontend/checkout/CheckoutComponent";
import CheckoutCartListComponent from "../../components/frontend/checkout/cartList/CartListComponent";
import CartListHeaderComponent from "../../components/frontend/checkout/cartList/HeaderComponent";
import CheckoutCheckoutComponent from "../../components/frontend/checkout/checkout/CheckoutComponent";
import CheckoutHeaderComponent from "../../components/frontend/checkout/checkout/HeaderComponent";
import CheckoutPaymentComponent from "../../components/frontend/checkout/payment/PaymentComponent";
import PaymentHeaderComponent from "../../components/frontend/checkout/payment/HeaderComponent";
import ProductReviewComponent from "../../components/frontend/account/review/ProductReviewComponent";
import MostPopularProductComponent from "../../components/frontend/product/MostPopularProductComponent.vue";

export default [
    {
        path: "/",
        component: HomeComponent,
        name: "frontend.home",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/productos",
        component: ProductComponent,
        name: "frontend.product",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/categorias",
        component: CategoryGridComponent,
        name: "frontend.categories",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/categorias/:slug",
        component: CategoryChildrenGridComponent,
        name: "frontend.categories.children",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/productos/:slug",
        component: ProductDetailsComponent,
        name: "frontend.product.details",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/ofertas",
        component: OfferProductComponent,
        name: "frontend.offers",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/promo/:slug",
        component: PromotionProductComponent,
        name: "frontend.promotion.products",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/seccion/:slug",
        component: ProductSectionProductComponent,
        name: "frontend.productSection.products",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/populares",
        component: MostPopularProductComponent,
        name: "frontend.mostPopular.products",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },

    {
        path: "/ofertas-flash",
        component: FlashSaleProductComponent,
        name: "frontend.flashSale.products",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/wishlist",
        component: WishlistComponent,
        name: "frontend.wishlist",
        meta: {
            isFrontend: true,
            auth: true,
        },
    },
    {
        path: "/info/:slug",
        component: PageComponent,
        name: "frontend.page",
        meta: {
            isFrontend: true,
            auth: false,
        },
    },
    {
        path: "/usuario",
        component: AccountComponent,
        name: "frontend.account",
        redirect: {name: "frontend.account.overview"},
        meta: {
            isFrontend: true,
            auth: true,
        },
        children: [
            {
                path: "vista-general",
                component: OverviewComponent,
                name: "frontend.account.overview",
                meta: {
                    isFrontend: true,
                    auth: true
                }
            },
            {
                path: "pedidos",
                component: OrderHistoryComponent,
                name: "frontend.account.orderHistory",
                meta: {
                    isFrontend: true,
                    auth: true,
                }
            },
            {
                path: "devoluciones",
                component: ReturnOrdersComponent,
                name: "frontend.account.returnOrders",
                meta: {
                    isFrontend: true,
                    auth: true,
                }
            },
            {
                path: "devoluciones/detalle/:id",
                component: ReturnOrderDetailsComponent,
                name: "frontend.account.returnOrder.details",
                meta: {
                    isFrontend: true,
                    auth: true,
                }
            },
            {
                path: "devoluciones/solicitud/:id",
                component: ReturnOrderRequestComponent,
                name: "frontend.account.returnOrder.request",
                meta: {
                    isFrontend: true,
                    auth: true,
                }
            },
            {
                path: "review/:slug",
                component: ProductReviewComponent,
                name: "frontend.account.productReview",
                meta: {
                    isFrontend: true,
                    auth: true,
                }
            },
            {
                path: "review/editar/:slug/:id",
                component: ProductReviewComponent,
                name: "frontend.account.productReview.edit",
                meta: {
                    isFrontend: true,
                    auth: true,
                }
            },
            {
                path: "pedidos/detalle/:id",
                component: OrderDetailsComponent,
                name: "frontend.account.orderDetails",
                meta: {
                    isFrontend: true,
                    auth: true,
                },
            },
            {
                path: "cuenta/perfil",
                component: AccountInfoComponent,
                name: "frontend.account.accountInfo",
                meta: {
                    isFrontend: true,
                    auth: true,
                },
            },
            {
                path: "cuenta/password",
                component: ChangePasswordComponent,
                name: "frontend.account.changePassword",
                meta: {
                    isFrontend: true,
                    auth: true,
                },
            },
            {
                path: "cuenta/direcciones",
                component: AddressComponent,
                name: "frontend.account.address",
                meta: {
                    isFrontend: true,
                    auth: true,
                },
            }
        ]
    },
    {
        path: "/checkout",
        component: CheckoutComponent,
        name: "frontend.checkout",
        redirect: {name: "frontend.checkout.checkout"},
        meta: {
            isFrontend: true,
            auth: true,
        },
        children: [
            {
                path: "carrito",
                components: {default : CheckoutCartListComponent, header: CartListHeaderComponent},
                name: "frontend.checkout.cartList",
                meta: {
                    isFrontend: true,
                    auth: true
                }
            },
            {
                path: "entrega",
                components: {default: CheckoutCheckoutComponent, header: CheckoutHeaderComponent},
                name: "frontend.checkout.checkout",
                meta: {
                    isFrontend: true,
                    auth: true
                }
            },
            {
                path: "pago",
                components: {default: CheckoutPaymentComponent, header: PaymentHeaderComponent},
                name: "frontend.checkout.payment",
                meta: {
                    isFrontend: true,
                    auth: true
                }
            }
        ]
    }
];
